import React from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import { FontFamily } from '../../../constants/fonts';
import { useTheme } from '../../../theme';
import { createExecutionSummaryReportStyles } from '../../AnalyticsHub/styles/executionSummaryReportStyles';

interface TicketingAnalyticsPlaceholderTabProps {
  icon: string;
  title: string;
  description: string;
}

const TicketingAnalyticsPlaceholderTab: React.FC<TicketingAnalyticsPlaceholderTabProps> = ({
  icon,
  title,
  description,
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark' && Platform.OS !== 'web';
  const executionSummaryReportStyles = createExecutionSummaryReportStyles(isDark, colors);
  return (
    <View style={[executionSummaryReportStyles.placeholderWrap, styles.placeholderPane]}>
      <MaterialIcons name={icon as any} size={48} color={isDark ? colors.brand.primary : '#005CBC'} />
      <Text style={[styles.placeholderTitle, isDark && { color: colors.text.primary }]}>{title}</Text>
      <Text style={executionSummaryReportStyles.placeholderText}>{description}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  placeholderPane: {
    marginTop: 6,
  },
  placeholderTitle: {
    fontSize: 20,
    fontFamily: FontFamily.bold,
    color: '#2D2F33',
    marginTop: 12,
    marginBottom: 8,
    textAlign: 'center',
  },
});

export default TicketingAnalyticsPlaceholderTab;






